import { render, staticRenderFns } from "./ReceiptPayment.vue?vue&type=template&id=1c843af4"
import script from "./ReceiptPayment.vue?vue&type=script&lang=js"
export * from "./ReceiptPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports